import React from 'react';
import StarRating from '../StarRating/StarRating';

import './StarRatingBox.css';
import { TopOperators } from '../../pages/runtime-typechecker';
type StarRatingBoxProps = {
  topOperatorsList: TopOperators[];
};
const StarRatingBox = ({ topOperatorsList }: StarRatingBoxProps) => {
  if (topOperatorsList.length > 0) {
    return (
      <div className="starRatngWrap">
        <div className={`scrollable`}>
          <ul className="starRatngWrap__list ">
            {topOperatorsList.map(
              ({ operatorName, rating, numberOfRatings, seoUrl }, idx) => (
                <li key={'startRating_' + idx}>
                  {seoUrl ? (
                    <a href={seoUrl} className="starRatngWrap__list--title">
                      {operatorName}
                    </a>
                  ) : (
                    <span className="starRatngWrap__list__nohover--title ">
                      {operatorName}
                    </span>
                  )}
                  <span className="starRatngWrap__list--ratingInfo">
                    <span className="">
                      <StarRating
                        starValue={rating}
                        iconWidth={10}
                        iconHeight={10}
                        customStyle={{ marginRight: '2px' }}
                      />
                    </span>
                    {/* <span className="font12 lightGreyText paddingL30 desktopShow">{`based on ${numberOfRatings} ratings`}</span>
                  <span className="font12 lightGreyText mobileShow ">{`${numberOfRatings} ratings`}</span> */}
                  </span>
                </li>
              ),
            )}{' '}
          </ul>
        </div>
      </div>
    );
  }
  return <div></div>;
};
export default StarRatingBox;
